export default {
  sidebarVisible: state => state.sidebarVisible,
  token: state => state.token,
  username: state => state.user.name,
  spname: state => state.user.sp_name,
  sp_id: state => state.user.sp_id,
  avatar: state => state.user.avatar,
  report_loading: state => state.report.loading,
  report_saving: state => state.report.saving,
  report_form_html: state => state.report.form_html,
  report_common_fault_loading: state => state.report.common_fault_loading,
  report_common_fault: state => state.report.common_fault,
  report_list_loading: state => state.report_list.loading,
  report_list_columns: state => state.report_list.columns,
  report_list_data: state => state.report_list.data,
  report_list_total: state => state.report_list.total,
  report_list_additional_parameters: state => state.report_list.additional_parameters,
  report_query_querying: state => state.report_query.querying,
  report_query_can_report_directly: state => state.report_query.can_report_directly,
  company_info_name: state => state.company_info.name,
  company_info_cus_dept: state => state.company_info.cus_dept,
  company_info_link_man: state => state.company_info.link_man,
  report_report_detail_loading: state => state.report_detail.loading,
  report_report_detail_ticket: state => state.report_detail.ticket,
  report_report_detail_no: state => state.report_detail.no,
  report_report_detail_videos: state => state.report_detail.videos,
  report_report_detail_voices: state => state.report_detail.voices,
  report_report_detail_attachments: state => state.report_detail.attachments,
  report_report_detail_service_ticket: state => state.report_detail.service_ticket,
  report_report_detail_service_ticket_loaded: state => state.report_detail.service_ticket_loaded,
  info_loading: state => state.info.loading,
  info_saving: state => state.info.saving,
  info_user_name: state => state.info.user_name,
  info_is_verified: state => state.info.is_verified,
  report_steps_querying: state => state.report_steps.querying,
  report_steps_steps: state => state.report_steps.steps,
  report_steps_current: state => state.report_steps.current,
}



// WEBPACK FOOTER //
// ./src/store/getters.js